import { render, staticRenderFns } from "./ResponsibilityCurrentBadgeHolderList.vue?vue&type=template&id=6fcebb76&scoped=true"
import script from "./ResponsibilityCurrentBadgeHolderList.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityCurrentBadgeHolderList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityCurrentBadgeHolderList.vue?vue&type=style&index=0&id=6fcebb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcebb76",
  null
  
)

export default component.exports